export const NAVIGATION = [
  { name: 'Intelligence', href: '/intelligence' },
  { name: 'Creative Services', href: '/creative-services' },
  { name: 'Solutions', href: '/solutions' },
  { name: 'Plans', href: '/plans' },
  { name: 'Work', href: '/work' },
  { name: 'About', href: '/about' },
  { name: 'Insights', href: '/insights' },
];

export const INDUSTRIES = [
  'Financial Services and Fintech',
  'Real Estate and Property',
  'FMCG and Retail',
  'Hospitality and Travel',
  'Healthcare',
  'Education',
  'Technology and SaaS',
  'E-commerce',
  'Professional Services',
  'NGOs and Public-Interest Organisations'
];

export const SOLUTIONS = [
  {
    id: 1,
    problem: 'We do not know what competitors are doing.',
    solution: 'Competitive Advertising Intelligence',
    explanation: 'Maxmark monitors selected competitors’ public advertising activity, identifies meaningful creative and commercial patterns, and provides clear recommendations for your brand.',
    cta: 'Request a Market Review',
    link: '/request-review'
  },
  {
    id: 2,
    problem: 'Our campaigns lack a clear creative direction.',
    solution: 'Campaign Strategy & Creative System',
    explanation: 'We clarify the campaign objective, audience, message, offer and creative system before production begins.',
    cta: 'Plan a Campaign',
    link: '/contact'
  },
  {
    id: 4,
    problem: 'Our brand looks outdated or unclear.',
    solution: 'Brand Strategy & Identity',
    explanation: 'We strengthen positioning, messaging and visual identity so the brand becomes more distinctive, relevant and consistent.',
    cta: 'Request a Brand Audit',
    link: '/contact'
  },
  {
    id: 5,
    problem: 'Our website is not converting.',
    solution: 'Web, UX & Conversion Experience',
    explanation: 'We design strategic websites and landing pages that communicate clearly, guide visitors and support measurable business actions.',
    cta: 'Review Your Website',
    link: '/contact'
  },
  {
    id: 7,
    problem: 'Our marketing activities are disconnected.',
    solution: 'Integrated Growth Partnership',
    explanation: 'Maxmark connects intelligence, strategy, content, campaigns, digital experience and measurement within one coherent growth system.',
    cta: 'Book a Strategy Session',
    link: '/contact'
  }
];

export const INSIGHT_CATEGORIES = [
  'Competitor Advertising Signals',
  'Creative Strategy',
  'Brand & Digital Growth',
  'African Market Intelligence',
  'Maxmark Case Notes'
];